import { store, getContext, getServerState, getElement } from '@wordpress/interactivity';

const { state } = store( 'gt/filtres-categories', {
	state: {
		promotions: [],
	},
	actions: {
		filterCategory: () => {

            const destinationUrl = new URL(window.location);

            const element = getElement();

            const category = element.attributes['data-category'];

            if (category) {
                destinationUrl.searchParams.set('taxonomy', 'category');
                destinationUrl.searchParams.set('tag_ID', category);
            } else {
                destinationUrl.searchParams.delete('taxonomy');
                destinationUrl.searchParams.delete('tag_ID');
            }

            element.ref.parentElement.querySelectorAll('.active').forEach((button) => {
                button.classList.remove('active');
            });
            element.ref.classList.add('active');

            updateUrl(destinationUrl);

		}
	},
	callbacks: {
		
	},
} );

const updateUrl = async (url) => {
    const router = await import('@wordpress/interactivity-router');
    await router.actions.navigate(url.toString(), {
        replace: true,
        force:true
    });
};